import { useState } from 'react';
import Modal from './Modal';
import './ProfileCompleteModal.css';

export default function ProfileCompleteModal({ isOpen, onComplete }) {
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setError('');

    if (!firstname.trim() || !lastname.trim()) {
      setError('Bitte füllen Sie beide Felder aus');
      return;
    }

    setLoading(true);

    try {
      await onComplete(firstname.trim(), lastname.trim());
    } catch (err) {
      setError(err.message || 'Fehler beim Speichern des Profils');
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Profil vervollständigen"
      type="info"
      onClose={() => {}} // Nicht schließbar
      actions={
        <button
          type="button"
          className="modal-button modal-button-primary"
          disabled={loading}
          onClick={() => handleSubmit()}
        >
          {loading ? 'Speichern...' : 'Profil speichern'}
        </button>
      }
    >
      <form onSubmit={handleSubmit} className="profile-complete-form" id="profile-form">
        <p className="profile-complete-description">
          Bitte geben Sie Ihren Vor- und Nachnamen ein. Diese Daten werden für Bestellungen benötigt.
        </p>

        {error && (
          <div className="profile-error">
            ⚠️ {error}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="firstname">Vorname *</label>
          <input
            id="firstname"
            type="text"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            placeholder="Max"
            disabled={loading}
            autoFocus
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastname">Nachname *</label>
          <input
            id="lastname"
            type="text"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            placeholder="Mustermann"
            disabled={loading}
            required
          />
        </div>
      </form>
    </Modal>
  );
}
